export default "__VITE_ASSET__6SYEXGQ1__"